import axios from 'axios'

import { BASE_API_PATH, TOKEN_KEY } from '@/util/variable'
import { ElMessage } from 'element-plus'
import router from '@/router'
import { removeToken, getToken, LocalStore } from '@/util/common'
import { loading } from '@/util/loading'
const LoginPath = '/login'



export const SUCCESS_CODE = 200

const filterApiUrl = [
  '/system/version'
]

export const request = axios.create({
  withCredentials: false,
  baseURL: BASE_API_PATH,
  timeout: 1000 * 30,
})

export const post = function (url, data = {}, params = {}, ext = {}) {
  ext = typeof ext === 'string' ? { responseType: ext } : ext
  return request({
    ...ext,
    params,
    method: 'POST',
    url,
    data: data,
  })
}

export const put = function (url, data = {}) {
  return request({
    method: 'PUT',
    url,
    data
  })
}

export const patch = function (url, data = {}, ext = {}) {
  return request({
    method: 'PATCH',
    url,
    data,
    ...ext
  })
}

export const get = function (url, params = {}, ext, _hideError = false) {
  return request({
    method: 'GET',
    url,
    params,
    _hideError,
    ...ext
  })
}

export const remove = function (url, params = {}, ext) {
  return request({
    method: 'DELETE',
    url,
    params,
    ...ext
  })
}

export const getStream = function(url, params = {}) {
  return get(url, params, {
    responseType: 'arraybuffer'
  })
}

export const postStream = function(url, data = {}, params = {}) {
  return post(url, data, params, {
    responseType: 'arraybuffer'
  })
}

export const showNotification = (message, description, key, show = true) => {
  if (show) {
    ElMessage.error({
      message: description,
      type: 'warning',
    })
  }
}

export const TokenLose = () => {
  showNotification('Unauthorized', '用户未登录', '401')
}

const errorHandler = (error) => {
  if (error.response) {
    console.log(error)
    const data = error.response.data
    const status = error.response.status
    if(data instanceof Blob){
      data.text().then((res)=>{
        showNotification(error.message, (JSON.parse(res).message + '').substr(0,90))
      })
    }else{
       if (status === 403) {
         showNotification('Forbidden', (data.msg + '').substr(0, 90), '403')
       } else if (status === 500) {
        const queryPreset = new RegExp('/function/QueryPreset')
        if(queryPreset.test(error.config.url)){
          showNotification('Server Side Error', ('该通道无预置点位' + '').substr(0, 90), '500')
        }else{
          showNotification('Server Side Error', (data.msg + '').substr(0, 90), '500')
        }
       } else if (status === 400) {
         showNotification('Request Error', (data.msg + '').substr(0, 90), '400')
       } else if (status === 401) {
         TokenLose()
          window.dispatchEvent(new Event('ws-disconnect'))
         setTimeout(() => {
           // 通知关闭 WebSocket，避免退出后仍重连
           localStorage.clear()
          //  router.replace({
          //    path: LoginPath
          //  })
           window.location.href = LoginPath
         }, 100)
       } else if (status === 404 && !error.config._hideError) {
         const data = error?.response?.data
         const message = error?.response?.data?.message || `${data?.error} ${data?.path}`
         showNotification(error?.code, message, '404')
       }
    }
  } else if (error.response === undefined) {
    if (error.message.includes('timeout')) {
      showNotification(error.message, '接口响应超时', undefined)
    } else {
      showNotification(error.message, (error.stack + '').substr(0, 90), undefined)
    }
  }
  return Promise.reject(error)
}

request.interceptors.request.use(config => {
  const token = getToken()
  const isFilterUrl = filterApiUrl.some(url => config.url.includes(url))
  if (!token && !isFilterUrl) {
    setTimeout(() => {
      removeToken()
      router.replace({
        path: LoginPath
      })
    }, 0)
    return config
  }

  config.headers[TOKEN_KEY] = token
  config.headers['Authorization'] = 'Bearer '+token

  if (config._showLoading) {
    loading.show()
  }

  return config
}, errorHandler)

request.interceptors.response.use(response => {
  loading.hide()
  
  if (response.data instanceof ArrayBuffer) {
    return response
  } else {
    const { status, message } = response.data
    if (typeof response.data === 'object' && typeof response.data.success === 'undefined') {
      response.data.success = status === SUCCESS_CODE
    }

    if (response.headers['content-type'] === 'application/octet-stream; charset=UTF-8' || response.headers['content-type'] === 'application/vnd.ms-excel;charset=UTF-8') {
      return response.data
    } else {
      return response.data
    }
  }
}, error => {
  loading.hide()
  return errorHandler(error)
})

export default {
  request,
  post,
  get,
  patch,
  put,
  remove,
  getStream,
  postStream
}